export const LOADING_MEALS = 'loading_meals';
export const ERROR_MEALS = 'error_meals';
export const SUCCESS_MEALS = 'success_meals';
export const IDLE_MEALS = 'idle_meals';

export const LOADING_MEAL = 'loading_meal';
export const ERROR_MEAL = 'error_meal';
export const SUCCESS_MEAL = 'success_meal';
export const IDLE_MEAL = 'idle_meal';

export const CHANGE_CATEGORY = 'change_category';
